import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function getInternalTeam() {
  try {
    const data = await authenticatedFetch(URL.getInternalTeam);
    return data;
  } catch (error) {
    console.error("Error fetching tickets KPI details:", error);
    throw error;
  }
}
